import React from 'react';
import './SocialLinks.css';
import useSocialLinks from '../common/socialLinksApi';

// Social icon images (use local images only)
import facebookIcon from '../assets/icon/facebook.png';
import instagramIcon from '../assets/icon/instagram.png';
import youtubeIcon from '../assets/icon/youtube.png';
import bgImage from "../assets/imges/image.png";
const iconFor = (name) => {
    if (!name) return null;
    const n = name.toLowerCase();
    if (n.includes('facebook')) return <img src={facebookIcon} alt="facebook" />;
    if (n.includes('instagram')) return <img src={instagramIcon} alt="instagram" />;
    if (n.includes('youtube') || n.includes('yt')) return <img src={youtubeIcon} alt="youtube" />;
    return null;
};

const ALLOWED_PLATFORMS = ['facebook', 'instagram', 'youtube'];

const SocialLinks = () => {
    const { data: links, loading, error, errorStatus, errorBody, errorEndpoint, raw, endpoint, refresh } = useSocialLinks(ALLOWED_PLATFORMS);

    React.useEffect(() => {
        if (raw) {
            console.debug('SocialLinks raw response from', endpoint, raw);
        }
        console.debug('SocialLinks links prop', links);
    }, [raw, endpoint]);

    if (loading) return null;

    if (error) return (
        <div className="social-links-container">
            <div className="social-links-error">
                <div>⚠️ {error}</div>
                {/** Show additional diagnostics when available */}
                {raw ? null : (
                    <div style={{ marginTop: 8, color: '#666', fontSize: '0.85rem' }}>
                        {/** show endpoint and server details from hook */}
                        <div>Endpoint: <strong>{errorEndpoint || endpoint || 'N/A'}</strong></div>
                        <div>Status: <strong>{errorStatus || 'N/A'}</strong></div>
                        {errorBody ? (
                            <details style={{ marginTop: '6px' }}>
                                <summary style={{ cursor: 'pointer' }}>View server response</summary>
                                <pre style={{ maxHeight: '220px', overflow: 'auto' }}>{errorBody}</pre>
                            </details>
                        ) : null}
                        <div style={{ marginTop: 6, color: '#999', fontSize: '0.8rem' }}>
                            Tip: If this is a non-JSON response (HTML), ensure the backend endpoint is correct and returns JSON, or configure Vite proxy/CORS.
                        </div>
                    </div>
                )}
            </div>
        </div>
    );

    if (!links || links.length === 0) {
        return (
            <div className="social-links-container social-links-empty">
                <p>📭 No social links available</p>
                <p style={{ fontSize: '0.85rem', color: '#666', marginTop: '8px' }}>
                    Check the browser console for the API response. Click <strong>Refresh</strong> to re-fetch the data.
                </p>
                {raw ? (
                    <div style={{ marginTop: '8px', fontSize: '0.8rem', color: '#444' }}>
                        <div>Endpoint: <strong>{endpoint}</strong></div>
                        <details style={{ marginTop: '6px' }}>
                            <summary style={{ cursor: 'pointer' }}>Show raw response</summary>
                            <pre style={{ maxHeight: '220px', overflow: 'auto' }}>{JSON.stringify(raw, null, 2)}</pre>
                        </details>
                    </div>
                ) : null}
            </div>
        );
    }

    return (
        <div className="social-links-container">
            <div
                className="social-links-card"
                style={{ backgroundImage: `url(${bgImage})` }}
            >

                <div className="social-links-grid">
                    {links.map((link) => (
                        <a
                            key={link.name || link.url}
                            className="social-link"
                            data-platform={link.platform}
                            href={link.url}
                            title={link.name}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <span className="social-link-icon">{iconFor(link.platform || link.name) || '🔗'}</span>
                            <span className="social-link-name">{(link.platform ? (link.platform.charAt(0).toUpperCase() + link.platform.slice(1)) : link.name)}</span>
                        </a>
                    ))}
                </div>
                {/* <div className="social-links-refresh">
                    <span style={{ marginRight: 8, color: '#666', fontSize: '0.85rem' }}>
                        Showing {links.length} link{links.length !== 1 ? 's' : ''}
                    </span>
                    <button onClick={refresh} className="btn-refresh">Refresh</button>
                </div> */}
            </div>
        </div>
    );
};

export default SocialLinks;
